import { Link2, PenLine } from "lucide-react";
import { LGoButton } from "@/ui/branded";
import { offerAuthoringCopy } from "@/features/offers/offer-authoring-copy";

interface InheritedValueNoteProps {
  templateValueText: string;
  isOverridden: boolean;
  onRestore: () => void;
}

export function InheritedValueNote({
  templateValueText,
  isOverridden,
  onRestore,
}: InheritedValueNoteProps) {
  if (!isOverridden) {
    return (
      <p className="flex items-center gap-1.5 text-sm text-muted-foreground">
        <Link2 className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
        {offerAuthoringCopy.inherited}
      </p>
    );
  }

  return (
    <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
      <p className="flex items-center gap-1.5 text-sm text-foreground">
        <PenLine className="h-3.5 w-3.5 shrink-0 text-muted-foreground" aria-hidden="true" />
        {offerAuthoringCopy.overridden(templateValueText)}
      </p>
      <LGoButton
        type="button"
        variant="ghost"
        size="sm"
        aria-label={offerAuthoringCopy.restoreAria(templateValueText)}
        onClick={onRestore}
      >
        {offerAuthoringCopy.restore}
      </LGoButton>
    </div>
  );
}
